export default __webpack_public_path__ + "static/media/compressed-biogas-icon.467f2fd4.svg";